import { Alert } from "@theorgchartdev/storybook";
import { GetDoc } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";
import {
  kPersonID,
  kSupervisorID,
  kEmployeeID,
  kEmployeePositionID,
  kPositionID,
  kParentPositionID
} from "@coreapp/constants";

export const GetDefinitionData = (definition: Record<string, any>) => {
  let data: Array<{ field: string; value: string }> = [];
  for (let aDefIdx in definition) {
    let option: { field: string; value: string } = { field: "", value: "" };
    let theField = aDefIdx;
    if (theField === "_branchlevel") theField = appstr("Branch Level");
    option.field = theField;

    let theValue = definition[aDefIdx];
    if (theValue === "_self") theValue = appstr("User Value");

    option.value = theValue;

    if (Array.isArray(theValue)) {
      option.value = theValue.reduce((acc, curr, index) => {
        let curValue = curr;
        if (curValue === "_self") curValue = appstr("User Value");
        return acc + (index > 0 ? ", " : "") + curValue;
      }, "");
    }
    data.push(option);
  }
  return data;
};

export const GetFeedbackAlert = (message: string) => {
  return (
    <Alert alertActions={{ closeAction: undefined }} severity="warning">
      {message}
    </Alert>
  );
};

export const GetAvailableFields = () => {
  let headers = [];
  const curDoc = GetDoc();
  if (curDoc) headers = curDoc.GetTargetHeaders(true, false, true, true, []);
  return headers;
};

export const enumRuleSets = {
  allowed: "allowedFields",
  restricted: "restrictedFields",
  conditional: "conditionalFields"
};

export const getReselectionAfterDelete = (
  deletedIdx: number,
  // undefined at runtime because changeRuleSet's dead semicolon lets undefined through; `== null` absorbs both
  selectedConditionalRule: string | null | undefined,
  remainingLength: number,
  selectedRule: string
): { selectedConditionalRule: string | null; selectedRule?: string } => {
  if (remainingLength === 0) {
    return {
      selectedConditionalRule: null,
      ...(selectedRule === enumRuleSets.conditional ? { selectedRule: enumRuleSets.allowed } : {})
    };
  }
  if (selectedConditionalRule == null) return { selectedConditionalRule: null };

  const selectedIdx = parseInt(selectedConditionalRule, 10);
  if (deletedIdx === selectedIdx) {
    return { selectedConditionalRule: Math.min(deletedIdx, remainingLength - 1).toString() };
  }
  if (deletedIdx < selectedIdx) {
    return { selectedConditionalRule: (selectedIdx - 1).toString() };
  }
  return { selectedConditionalRule };
};

export const disabledEmployeeFields = [kPersonID, kSupervisorID];
export const disabledPositionFields = [kPositionID, kParentPositionID];
export const disabledHolderFields = [kEmployeeID, kEmployeePositionID];
